import { cn } from '@/lib/classnames';
import type { RecipeFormData } from './form-types';
import {
  ALLERGENS, DIETARY_FLAGS 
} from './form-constants';

interface MetadataTabProps {
  readonly formData: RecipeFormData;
  readonly toggleArrayItem: (field: 'allergens' | 'dietaryFlags' | 'subRecipeIds', value: string) => void;
}

export function MetadataTab({
  formData, toggleArrayItem 
}: MetadataTabProps) {
  return (
    <div className="space-y-6">
      {/* Allergens */}
      <div className="space-y-3">
        <label className="text-sm font-medium">Allergens</label>
        <p className="text-xs text-muted-foreground">
          Select all allergens present in this recipe
        </p>
        <div className="flex flex-wrap gap-2">
          {ALLERGENS.map((allergen) => (
            <button
              key={allergen.value}
              type="button"
              onClick={() => toggleArrayItem('allergens', allergen.value)}
              className={cn(
                'rounded-full px-3 py-1.5 text-sm font-medium transition-all',
                formData.allergens.includes(allergen.value)
                  ? 'bg-amber-100 text-amber-800 ring-2 ring-amber-300'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              )}
            >
              {allergen.label}
            </button>
          ))}
        </div>
      </div>

      {/* Dietary Flags */}
      <div className="space-y-3">
        <label className="text-sm font-medium">Dietary Flags</label>
        <p className="text-xs text-muted-foreground">
          Select dietary classifications for this recipe
        </p>
        <div className="flex flex-wrap gap-2">
          {DIETARY_FLAGS.map((flag) => (
            <button
              key={flag.value}
              type="button"
              onClick={() => toggleArrayItem('dietaryFlags', flag.value)}
              className={cn(
                'rounded-full px-3 py-1.5 text-sm font-medium transition-all',
                formData.dietaryFlags.includes(flag.value)
                  ? 'bg-green-100 text-green-800 ring-2 ring-green-300'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              )}
            >
              {flag.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
